import axios from 'axios';
import uuidv1 from 'uuid';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 30000;
import config from '@/config/config';
const contextPath = config.contentPath;
export default class Http
{
    static getContentPath() {
        return contextPath;
    }
    static get(url, params)
    {
        let token = localStorage.getItem('system-token')
        return axios.get(`${contextPath}${url}`,{headers:{'system-token':token}}).
        then((response) =>
        {
            console.log(response);
            if(response.status == 200)
            {
                return new HttpResponse(response.data);
            }
            return new HttpResponse({
                code: HttpResponse.ERROR_CODE,
                msg: '请求失败'
            });
        }).
        catch((error) =>
        {
            return new HttpResponse({
                code: HttpResponse.ERROR_CODE,
                msg: '请求失败'
            });
        });
    }

    static post(url, parameter)
    {
        console.log('contentPath>>>>', contextPath);
        url = `${contextPath}${url}`;
        // let data = {requestId: uuidv1(), parameter};
        let token = localStorage.getItem('system-token')
        return axios({
            method: 'post',
            url: url,
            headers:{'system-token':token},
            data: parameter||{},
        }).
        then((response) =>
        {
            console.log(url,response);
            return new HttpResponse(response.data);
        }).
        catch((error) =>
        {
            console.error('post error >>', error);
            if(error.response)
            {
                let response = error.response;
                if(response.status == 401)
                {
                    return Fx.$globalVue.$confirm('您的会话信息已过期，是否重新登录？', '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).
                    then(()=>
                    {
                        if(process.env.NODE_ENV == 'development')
                        {
                            window.location.href = '/index.html';
                        } else
                        {
                            window.location.href = contextPath+'/index.html';
                        }
                    }).
                    catch(()=>
                    {
                    });

                }
                if (response.status == 403)
                {
                    console.error("没有权限", response);
                    return new HttpResponse(response.data);
                }
            }
            return new HttpResponse({
                code: HttpResponse.ERROR_CODE,
                msg: '请求失败'
            });
        });
    }
    static upload(url, formData)
    {
        console.log('contentPath>>>>', contextPath);
        url = `${contextPath}${url}`;
        let token = localStorage.getItem('system-token');
        console.log('token', token)
        let headers = {'system-token': token};
        console.log(headers)
        // return axios.post(url, formData, headers).
        return axios({
            method: 'post',
            url: url,
            headers:{'system-token':token},
            data: formData,
        }).
        then((response) =>
        {
            console.log('upload',url,response);
            return new HttpResponse(response.data);
        }).
        catch((error) =>
        {
            console.error('post error >>', error);
            if(error.response)
            {
                let response = error.response;
                if(response.status == 401)
                {
                    return Fx.$globalVue.$confirm('您的会话信息已过期，是否重新登录？', '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).
                    then(()=>
                    {
                        if(process.env.NODE_ENV == 'development')
                        {
                            window.location.href = '/index.html';
                        } else
                        {
                            window.location.href = contextPath+'/index.html';
                        }
                    }).
                    catch(()=>
                    {
                    });

                }
                if (response.status == 403)
                {
                    console.error("没有权限", response);
                    return new HttpResponse(response.data);
                }
            }
            return new HttpResponse({
                code: HttpResponse.ERROR_CODE,
                msg: '请求失败'
            });
        });
    }

}

class HttpResponse
{
    static SUCCESS_CODE = 0;
    static ERROR_CODE = 999;
    /*
    {
      data?: string,
      code?: number,
      msg?: string
    }
    */
    response;

    constructor(response)
    {
        if(typeof response === 'string')
        {
            this.response = JSON.parse(response);
        } else
        {
            this.response = response;
        }
    }

    isSuccess()
    {
        return this.response.code == HttpResponse.SUCCESS_CODE;
    }

    getErrorMessage()
    {
        return this.response.msg;
    }

    getErrorCode()
    {
        return this.response.code;
    }

    getData(key)
    {
        if(key)
        {
            return this.response.data[key];
        }
        return this.response.data;
    }

    throwMessageError() {
        throw new Error(this.getErrorMessage()||"系统异常");
    }
}




// WEBPACK FOOTER //
// ./src/fx/Http.js